import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../PAcido";
import { plotBackground } from "../../../config/colors";


export default function ChimeneaPAS() {
  const [caudalChimenea, setCaudalChimenea] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [masaDeSO2, setMasaDeSO2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 5,
    secuencia: 45,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateCaudalChimenea(data);
    populateMasaDeSO2(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCaudalChimenea(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal Chimenea PAS Teórico"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalChimenea({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateMasaDeSO2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Masa de SO2 Emisión Chimenea PAS Teórico"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setMasaDeSO2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Chimenea PAS"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Caudal Chimenea PAS Teórico --------------------------------------- */}
            <Chart.Line
              name="Caudal Chimenea PAS Teórico"
              data={caudalChimenea.value}
              yAxis={0}
            />
            {/** -------------------------------- Masa de SO2 Emisión Chimenea PAS Teórico --------------------------------------- */}
            <Chart.Line
              name="Masa de SO2 Emisión Chimenea PAS Teórico"
              data={masaDeSO2.value}
              yAxis={1}
            />

           
            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={caudalChimenea.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={200000}
            />

            <Chart.YAxis
              labelSuffix=" kg/h"
              title="Emisión de SO2, kg/h"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={200000}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
